import getStore from '../store/store';
import { createDropViewState } from 'owa-dnd';
import { mutator } from 'satcheljs';
import {
    initializeTimePanelData,
    setLastEnterUpNext,
    resetCalendarUpNextState,
    setLastEnterCalendarTab,
    switchTabsOnHover,
    setLastEnterTasksTab,
    setDayViewDropTimeMinuteOffset,
    setShowDayDropHint,
} from '../actions/timePanelDndStoreActions';

mutator(initializeTimePanelData, () => {
    getStore().isTimePanelDataInitialized = true;
});

mutator(setLastEnterCalendarTab, actionMessage => {
    getStore().lastDragOverCalendarTab = actionMessage.lastTime;
});

mutator(switchTabsOnHover, actionMessage => {
    switch (actionMessage.nextView) {
        case 'Calendar':
            getStore().calendarTabDropViewState = createDropViewState();
            break;
        case 'Tasks':
            getStore().tasksTabDropViewState = createDropViewState();
            break;
    }
});

mutator(setLastEnterTasksTab, actionMessage => {
    getStore().lastDragOverTasksTab = actionMessage.lastTime;
});

mutator(setLastEnterUpNext, actionMessage => {
    getStore().lastDragOverUpNext = actionMessage.lastTime;
});

mutator(resetCalendarUpNextState, () => {
    getStore().upNextDropViewState = createDropViewState();
});

mutator(setShowDayDropHint, actionMessage => {
    getStore().shouldShowHoverDayDrop = actionMessage.shouldShow;
});

mutator(setDayViewDropTimeMinuteOffset, ({ dayViewDropTimeMinuteOffset }) => {
    getStore().dayViewDropTimeMinuteOffset = dayViewDropTimeMinuteOffset;
});
